import React from 'react';
import { Input as AntdInput } from '@firesoon/antd';
import Input from './Input';
import Search from './Search';
import TextArea from './AutoTextArea';
import Password from './Password';
import { FSInputProps, FSInputDecorator } from './interface';

const { Group } = AntdInput;

const InputCopy = Input as React.ForwardRefRenderFunction<AntdInput, FSInputProps>;

Object.assign(InputCopy, {
  Search,
  Group,
  TextArea,
  Password,
});

export default InputCopy as FSInputDecorator;